<template>
    <div>
        <CRow>
            <CCol md="12" class="mb-5">
                <CCard>
                    <CCardHeader>
                        <CRow>


                            <CCol col="4" style="text-align: start">
                                <strong>{{$t('components.driverDocumentList')}} {{ driver_name }}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: center">
                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton @click="send_porsant(0)" size="sm"
                                         color="secondary">
                                    تسویه پورسانت
                                </CButton>
                            </CCol>
                        </CRow>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>
                            <CCol col="4">
                                <treeselect
                                        v-model="refer_person"
                                        :async="true"
                                        :load-options="load_persons"
                                        :placeholder="$t('components.searchUser')"
                                        :normalizer="normalizer_persons"
                                />


                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>
                            </CCol>
                            <CCol col="1">
                                <CButton @click="get_lists_buy" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol>
                                جمع مبلغ پورسانت انتخابی: {{get_currency(all_selected_porsant())}}

                            </CCol>
                        </CRow>
                        <CDataTableFixed
                                :items="items_buy"
                                :fields="fields"
                                :sorter-value="{column:'masterFactorId', asc:false}"
                                :items-per-page="20"
                                hover
                                height="350px"
                                sorter
                                column-filter

                        >
                            <template #row="{item}">
                                <td>
                                    <p style="text-align:center">{{item.row_id+1}}</p>
                                </td>
                            </template>
                            <template #select-header="{item}">
                                <input type="checkbox" v-model="check_all_exit"
                                />
                            </template>
                            <template #select="{item}">
                                <td>
                                    <CCol v-if="(item.amount - get_return_amount(item) - item.payable)!=0">
                                        <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                               :value="item.masterId"/>
                                    </CCol>
                                </td>
                            </template>
                            <template #docDate="{item}">

                                <td>
                                    <p>{{get_date(item.docDate)}}</p>

                                </td>

                            </template>

                            <template #amount="{item}">
                                <td>
                                    <p style="text-align: right">{{get_currency(item.amount)}} </p>
                                </td>
                            </template>
                            <template #payable="{item}">
                                <td>
                                    <p style="text-align: right" v-if="item.payable">{{get_currency(item.payable)}} </p>
                                </td>
                            </template>
                            <template #totalFactor="{item}">
                                <td>
                                    <p style="text-align: right">{{get_currency(item.totalFactor)}} </p>
                                </td>
                            </template>
                            <template #retAmount="{item}">
                                <td>
                                    <p style="text-align: right">{{get_currency(item.retAmount)}} </p>
                                </td>
                            </template>
                            <template #receiveAmount="{item}">
                                <td>
                                    <p style="text-align: right">{{get_currency(item.receiveAmount)}} </p>
                                </td>
                            </template>
                            <template #factorRetAmount="{item}">
                                <td>
                                    <p style="text-align: right">{{get_currency(item.factorRetAmount)}} </p>
                                </td>
                            </template>
                            <template #remainingPrice="{item,index}">
                                <td>
                                    <!--                                            <p style="text-align: right">{{get_currency(item.amount - get_return_amount(item) - item.payable)}} </p>-->
                                    <p style="text-align: right">{{get_currency(item.remainingAmount)}} </p>
                                </td>
                            </template>
                            <template #masterCode="{item}">
                                <td>
                                    <p>{{item.masterCode}}</p>
                                </td>
                            </template>

                            <template #summary="{item}">
                                <td>
                                    <p>{{item.masterFactorTitle}}</p>
                                </td>
                            </template>

                          <template #caption>
                          <tr class="total-table">
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>{{$t('totalPrice')}}</td>

                            <td>{{get_currency(calculate_items(items_buy,'totalFactor'))}}</td>
                            <td>{{get_currency(calculate_items(items_buy,'factorRetAmount'))}}</td>
                            <td>{{get_currency(calculate_items(items_buy,'receiveAmount'))}}</td>
                            <td>{{get_currency(calculate_items(items_buy,'amount'))}}</td>
                            <td>{{get_currency(calculate_items(items_buy,'retAmount'))}}</td>
                            <td>{{get_currency(calculate_items(items_buy,'remainingAmount'))}}</td>
                          </tr>

                        </template>

                        </CDataTableFixed>

                    </CCardBody>

                </CCard>
                <CCard id="printMe_products_visitor">
                    <CCardHeader>
                        <strong>جمع کالاهای ویزیتور</strong>

                    </CCardHeader>
                    <CCardBody>
                        <CDataTableFixed
                                :items="items_products"
                                :fields="fields_products"
height="300px"
                                :items-per-page="200"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td>
                                    <strong>{{item.row_id+1}}</strong>

                                </td>

                            </template>
                            <template #product="{item}">

                                <td>
                                    <strong>{{item.productName}}</strong>

                                </td>

                            </template>

                            <template #qty="{item}">
                                <td>
                                    <strong style="text-align:center">{{Math.abs(item.productCount/item.unitValue)}}</strong>

                                </td>

                            </template>
                            <template #weight="{item}">

                                <td>
                                    <strong>{{item.weight}}</strong>

                                </td>


                            </template>
                            <template #unit="{item}">

                                <td>
                                    <strong>{{item.productUnitName}}</strong>

                                </td>

                            </template>


                        </CDataTableFixed>

                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>


            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';

    import Treeselect from '@riophae/vue-treeselect'
    // import the styles
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'

    import Vue from 'vue';
    import VueHtmlToPaper from 'vue-html-to-paper';
    // import FilterHeader from "../includes/FilterHeader";
    const options = {
        name: '_blank',
        specs: [
            'fullscreen=yes',
            'titlebar=yes',
            'scrollbars=yes',
        ],
        styles: [
            'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
            'https://unpkg.com/kidlat-css/css/kidlat.css',

        ]
    }

    Vue.use(VueHtmlToPaper, options);


    var simulateAsync = null
    const simulateAsyncOperation = fn => {
        if (simulateAsync != null) {
            clearTimeout(simulateAsync)
        }
        simulateAsync = setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            // FilterHeader,
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                show_document: 'test-dynamic',
                start_date: '',
                end_date: '',
                id_checkbox_items: [],
                name: '',
                check_all_exit: false,
                file: '',
                driver_name: '',
                color: '#ffffff',
                previewImage: '',
                submit_refer: 0,
                refer_person: null,
                refer_date: null,
                selected_template: 0,
                description: null,
                items_buy: items_data.map((item, row_id) => {
                    return {...item, row_id}
                }),
                items_final: items_data.map((item, row_id) => {
                    return {...item, row_id}
                }),

                items_products: [],
                fields: [

                    {key: 'row', label: this.$t('tables.row'), _style: 'width:5%'},
                    {key: 'docDate', label: this.$t('docDate'), _style: 'width:5%'},

                    {key: 'masterCode', label: this.$t('tables.factorId'), _style: 'width:10%'},
                    {key: 'partyName', label: this.$t('customer'), _style: 'width:10%'},
                    {key: 'totalFactor', label: this.$t('factorAmount'), _style: 'width:10%'},
                  {key: 'factorRetAmount', label: "مبلغ برگشتی", _style: 'width:10%'},
                  {key: 'receiveAmount', label: "مبلغ دریافتی", _style: 'width:10%'},

                  {key: 'amount', label: this.$t('tables.commission'), _style: 'width:10%'},
                    {key: 'retAmount', label: "پورسانت برگشتی", _style: 'width:10%'},
                    // {key: 'payable', label: "پرداخت شده", _style: 'width:10%'},
                    {key: 'remainingPrice', label: "مبلغ مانده", _style: 'width:10%'},
                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},
                  {key: 'select', label: "", _style: 'width:3%'},

                ],

                fields_products: [
                    {key: 'row', label: this.$t('tables.row'), _style: 'width:3%;padding:0px'},
                    {key: 'product', label: this.$t('tables.product'), _style: 'width:20%;padding:0px'},
                    {key: 'qty', label: this.$t('tables.qty'), _style: 'width:5%;padding:0px'},
                    {key: 'weight', label: this.$t('tables.weight'), _style: 'width:7%;padding:0px'},
                    {key: 'unit', label: this.$t('tables.unit'), _style: 'width:5%;padding:0px'},

                ],


                details: [],
                templates_items: [
                    {template_id: 'One', name: 'A'},
                    {template_id: 'Two', name: 'B'},
                    {template_id: 'Three', name: 'C'}
                ],
                collapseDuration: 0,
                status_form: 0,
                load_persons({action, searchQuery, callback}) {

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);
                            var url = "GetAllPersons";

                            formData.append('IsVendor', false);
                            formData.append('IsWorker', true);
                            formData.append('IsCustomer', false);
                            formData.append('IsActive', 0);

                            axios.post(url, formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                            })
                                .catch(function (error) {

                                    console.log(error);
                                });

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode + " " + node.userName + " " + node.surName + " " + node.mobileNo,
                    }
                },
            }
        },
        computed: {},
        mounted() {

            this.$root.root_validate_errors = [];
            this.get_lists_buy();

            this.start_date = this.get_day_before_today_in_day(30)
            this.end_date = this.get_today()
            // this.get_lists_buy();
            // this.get_lists_final();
            // this.get_lists_products();

            bus.$on('delete_confirm_cancel_refer' + this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });

            // this.$watch(
            //     () => {
            //       return this.$refs.filter_bar.start_date
            //     },
            //     (val) => {
            //       alert('App $watch $refs.counter.i: ' + val)
            // this.get_lists_buy();
            // this.get_lists_final();
            // this.get_lists_products();
            // })
            // this.$watch(
            //     () => {
            //       return this.$refs.filter_bar.end_date
            //     },
            //     (val) => {
            //       alert('App $watch $refs.counter.i: ' + val)
            // this.get_lists_buy();
            // this.get_lists_final();
            // this.get_lists_products();
            // })
        },
        watch: {
            'refer_person': function () {
                // if (this.refer_person!=null){
                //   this.get_lists_buy();
                //   // this.get_lists_final();
                //   // this.get_lists_products();
                // }

            },

            'check_all_exit': function () {
                var self = this
                if (this.check_all_exit) {
                    this.id_checkbox_items = [];

                    this.items_buy.forEach((val) => {
                        if ((val.amount - self.get_return_amount(val) - val.payable) != 0) {

                            this.id_checkbox_items.push(val.masterId);
                        }
                    });


                } else {
                    this.id_checkbox_items = [];
                }
            },
        },
        methods: {
            all_selected_porsant() {
                var self = this
                var total = 0;
                this.id_checkbox_items.forEach(function (val) {
                    var item = self.items_buy.filter(x => x.masterId == val)[0]
                    total += (item.amount - self.get_return_amount(item));
                })
                return total;
            },
            get_return_amount(item) {
                if (this.items_return.filter(x => x.masterId == item.masterId).length > 0) {
                    return this.items_return.filter(x => x.masterId == item.masterId)[0].amount
                } else {
                    return 0;
                }
            },
            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },

            print_products() {
                // Pass the element id here
                this.$htmlToPaper('printMe_products');
            },
            print() {
                // Pass the element id here
                this.$htmlToPaper('printMe');
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = this.items[item.row_id].unitName;
                this.color = this.items[item.row_id].color;
                this.description = this.items[item.row_id].description;
                this.previewImage = this.items[item.row_id].image;
                this.status_form = this.items[item.row_id].id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists_buy() {
                var self = this;


                const formData = new FormData();

                var url = "FactorPercentByPersonId";


                // formData.append("Status", 0);

                if (this.refer_person != null) {
                    // formData.append("FDate", this.refer_date);
                    formData.append("UserId", this.refer_person);
                } else {
                    return
                }
                formData.append("FirstDate", this.start_date);
                formData.append("SecondDate", this.end_date);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                      self.items_return = content_data.data.retFactors;

                      content_data.data.factors.forEach(function (val, index) {
                        if(val.payable==null){
                          val.payable = 0;
                        }
                        val.factorRetAmount = self.calculate_items(val.receiptAmount.filter(x=>x.paymentType==5),"price")
                        val.receiveAmount = self.calculate_items(val.receiptAmount.filter(x=>x.paymentType!=5),"price")
                        val.retAmount = self.get_return_amount(val);
                        // if (index == 0) {
                          val.remainingAmount = parseFloat(val.amount) - parseFloat(val.payable) - val.retAmount;
                        // } else {
                        //   val.remainingAmount = content_data.data.factors[index - 1].remainingAmount + parseFloat(val.amount) - parseFloat(val.payable) - val.retAmount;
                        //
                        // }

                      })
                      self.items_buy = content_data.data.factors.map((item, row_id) => {
                            return {...item, row_id}
                        });
                      console.log("factors",self.items_buy)
                        self.get_lists_products()

                        // self.driver_name = response.data.data.UserName;
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_lists_products() {
                var self = this;


                const formData = new FormData();

                var url = "GetPersonFactorProductInfos";

                if (this.refer_person != null) {
                    // formData.append("FDate", this.refer_date);
                    formData.append("UserId", this.refer_person);
                } else {
                    return
                }
                formData.append("FirstDate", this.start_date);
                formData.append("SecondDate", this.end_date);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.items_products = content_data.data.map((item, row_id) => {
                            return {...item, row_id}

                        });


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }
                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


            goEditPerson(item, index) {

                this.$router.push({path: '/dashboard/users/edit-user/' + this.items[index].userId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goShowDocument(item, index) {

                this.$router.push({path: '/dashboard/documents/show/' + item.masterFactorId});
                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
            goPrintDocument(item, index) {
                bus.$emit("print_confirm", item.masterFactorId);

                // this.$router.push({route_name: 'create_product' });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            send_porsant(index) {
                return false;
                if (this.id_checkbox_items.length == 0) {
                    return false;
                }
                var self = this;


                const formData = new FormData();

                var url = "AddFactorClearingPerson";

                var item = this.items_buy.filter(x => x.masterId == this.id_checkbox_items[index])[0]
                // formData.append("Status", 0);

                if (this.refer_person != null) {
                    // formData.append("FDate", this.refer_date);
                    formData.append("PersonId", this.refer_person);
                } else {
                    return
                }
                formData.append("MasterFactorId", this.id_checkbox_items[index]);
                formData.append("Amount", (item.amount - this.get_return_amount(item)));

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        if (index < self.id_checkbox_items.length - 1) {
                            self.send_porsant(index + 1)
                        } else {
                            self.id_checkbox_items = []
                            self.get_lists_buy()

                        }
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },

            delete_item_dialog(item, index) {
                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], 'delete_confirm_cancel_refer' + this.confirm_delete_name);

                this.status_form = item.masterFactorId;
            },
            delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "CancelFactorRefer";


                formData.append('id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists_buy();

                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

        },

    }

</script>
